/**
 * Webinar Info
 */
import { Component, registerComponent } from 'js/component.js';
import { hasDatePassed, formatIsoDateTime } from 'js/helpers.js';

const componentName = 'webinar-info';

export class WebinarInfo extends Component {

    /** Component setup */
    elements = {
        webinarDateItem: this.element.querySelector(`.${componentName}__item.startDate`),
        webinarTimeItem: this.element.querySelector(`.${componentName}__item.startTime`)
    };

    /** Initialize component */
    init() {
        // Determine webinar status (Upcoming or On-Demand)
        const webinarOnDemand = this.elements.webinarDateItem.dataset.ondemandTime;
        const webinarHasPassed = hasDatePassed(webinarOnDemand);
        let itemsToHide = null;

        if (webinarHasPassed) {
            this.elements.webinarDateItem.setAttribute('data-webinar-status', 'on-demand');
            document.querySelector('.hero-banner__text-container').setAttribute('data-webinar-status', 'on-demand');
            itemsToHide = this.element.querySelectorAll('.is-future');
        } else {
            itemsToHide = this.element.querySelectorAll('.is-past');
        }
        for (let i = 0; i < itemsToHide.length; i += 1) {
            itemsToHide[i].remove();
        }

        const eventStart = this.elements.webinarDateItem.dataset.startTime;
        const eventEnd = this.elements.webinarDateItem.dataset.endTime;

        const {
            startDate, fullTimeString
        } = formatIsoDateTime(eventStart, eventEnd);

        // Inject date and time formats to match locale of current site
        const dateContent = this.elements.webinarDateItem.innerHTML;
        const timeContent = this.elements.webinarTimeItem.innerHTML;
        const dateLabel = dateContent.substring(0, dateContent.lastIndexOf('/span>') + 6);
        const timeLabel = timeContent.substring(0, timeContent.lastIndexOf('/span>') + 6);

        this.elements.webinarDateItem.innerHTML = `${dateLabel} ${startDate}`;
        this.elements.webinarTimeItem.innerHTML = `${timeLabel} ${fullTimeString}`;
    }
}

registerComponent(`.${componentName}`, WebinarInfo);
